var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 56,
    viewBox: "0 0 36 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6481 1.47307L23.5561 25.9815L25.8254 2.38248L36 3.25591L31.5622 55.4655L23.5561 53.8856L12.145 29.7827L9.97648 53.6172L0 52.6424L4.3729 0.465515L13.6481 1.47307Z",
    fill: "#FFCC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/n.40818afd47a9c7ed708ba345049f34e3.svg";
export { ForwardRef as ReactComponent };